import { getFirstSuccessfulResponse } from "../http/apiClient";
import { wordpressBaseUrls } from "./endpoints";

export async function fetchWordPressResource({
  pathCandidates,
  params,
  signal,
}) {
  const { data, url } = await getFirstSuccessfulResponse({
    baseUrls: wordpressBaseUrls,
    pathCandidates,
    params,
    signal,
  });

  return { data, url };
}
